import script from "./WidgetNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetNavigation.vue?vue&type=script&setup=true&lang=js"

import "./WidgetNavigation.vue?vue&type=style&index=0&id=01a646cc&lang=scss"

const __exports__ = script;

export default __exports__